import PartnerCategories from "./PartnerCategories";

export default PartnerCategories;
